<ng-template [cdkPortalOutlet]="selectedPortal"></ng-template>
<ng-container>
  <app-call-header
    [class.d-none]="isLoading || callStore.getIsFullScreen()"
    [isLoading]="!!isLoading"
    [title]="callStore.getCall()?.callName"
    [sessionId]="callStore.getCall()?.practiceCallUuid"
    (sessionIdClicked)="copyToClipboard()"
  >
    <!--For visual aid V2-->
    <app-visual-aid-call-controls
      *ngIf="controlService && controlService.isVisualAidCall"
      [isMicOn]="callStore.getIsMicOn()"
      (microphoneClicked)="handleMuteClick()"
      [isPaused]="callStore.getIsPaused()"
      (playbackClicked)="handlePauseClick()"
      (endCallClicked)="handleEndCallClick()"
      [disableMicButton]=false
      [disableEndCallButton]=false
    />
  </app-call-header>

  <app-visual-aid-call-main
    [controlService]="controlService"
    [playerService]="playerService"
    *ngIf="
      controlService &&
      playerService &&
      deviceSettingsService &&
      this.controlService.isVisualAidCall
    "
    [class.d-none]="isLoading"
  >
    <qai-call-video
      avatarSlot
      [displayName]="playerService.avatarName"
      [isSpeaking]="showAvatarSpeakingBorder"
      [indicatorStatus]="showAvatarLoadingIndicator ? 'loading' : 'audio'"
    >
      <div class="videosStack" videoSlot>
        <video
          class="backgroundAvatarVideo"
          id="video-background-loop"
          preload="auto"
          [src]="playerService.loopClipFilename"
          muted
          [attr.playsinline]="true"
          [attr.webkit-playsinline]="true"
        ></video>

        <!-- List of videos in practice call -->
        <video
          *ngFor="
            let item of playerService.practiceCallClips;
            trackBy: trackBySrc
          "
          [id]="'avatar-video-' + item.index"
          [src]="item.src"
          [className]="item.className"
          preload="auto"
          [attr.playsinline]="true"
          [attr.webkit-playsinline]="true"
          (error)="avatarLoadingError($event, item)"
        ></video>
      </div>

      <qai-call-audio-indicator
        *ngIf="showAvatarSpeakingIndicator"
        size="medium"
        status="audio"
      />
      <!-- Don't show loading indicator for visual aid - listening loop-->
      <!-- <qai-call-audio-indicator
        *ngIf="showAvatarLoadingIndicator"
        size="medium"
        status="loading"
      /> -->
      <qai-call-captions
        *ngIf="controlService?.isCaptionsOn && playerService?.canPlayVideo"
        [displayName]="playerService.avatarName"
        [maxLines]="3"
      >
        {{ playerService.avatarSpeech() }}
      </qai-call-captions>
    </qai-call-video>
    <app-call-hint
      hintSlot
      *ngIf="showHints"
      [hint]="callStore.getHints()"
      [maxHeight]="callStore.getIsFullScreen() ? '20px' : '120px'"
    />
  </app-visual-aid-call-main>

  <!-- For visual aid V2 calls-->
  <app-visual-aid-call-footer
    *ngIf="controlService && playerService && controlService.isVisualAidCall"
    [isCaptionsOn]="controlService.isCaptionsOn"
    (settingsClicked)="deviceSettingsService?.displayDeviceSettingsModal()"
    (captionsClicked)="controlService.toggleCaptions()"
    [class.d-none]="isLoading || callStore.getIsFullScreen()"
  >
    <app-visual-aid-call-controls
      [isMicOn]="callStore.getIsMicOn()"
      (microphoneClicked)="handleMuteClick()"
      [isPaused]="callStore.getIsPaused()"
      (playbackClicked)="handlePauseClick()"
      (endCallClicked)="handleEndCallClick()"
    />
  </app-visual-aid-call-footer>
</ng-container>

<!-- Settings modal -->
<app-device-settings-modal
  *ngIf="deviceSettingsService?.displayModal"
  [deviceSettingsService]="deviceSettingsService"
  [controlService]="controlService"
></app-device-settings-modal>

<!-- End call early -->
<app-end-call-early
  *ngIf="controlService?.isEndCallTriggered && !callStore.getDisplayPostCall()"
  [controlService]="controlService"
  [playerService]="playerService"
></app-end-call-early>

<!-- End call succesful -->
<app-post-call
  *ngIf="callStore.getDisplayPostCall() && !hideResultsForLearners"
  [controlService]="controlService"
  [playerService]="playerService"
></app-post-call>

<app-post-call-hidden-results
  *ngIf="callStore.getDisplayPostCall() && hideResultsForLearners"
  [controlService]="controlService"
></app-post-call-hidden-results>

<!-- No response detected -->
<app-no-response-detected
  *ngIf="callStore.getOpenNoResponseModal()"
  [controlService]="controlService"
  [playerService]="playerService"
  [deviceSettingsService]="deviceSettingsService"
></app-no-response-detected>

<!-- Pause modal -->
<app-call-pause
  *ngIf="
    controlService &&
    callStore.getIsPaused() &&
    !deviceSettingsService?.displayModal &&
    !controlService.isEndCallTriggered &&
    !callStore.getOpenNoResponseModal() &&
    !controlService.displayTour &&
    !controlService.displayTourHint
  "
  [control]="controlService"
  [player]="playerService"
  [deviceSettings]="deviceSettingsService"
></app-call-pause>
